var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"free-card"}},[_c('div',{staticStyle:{"margin":"auto"},on:{"click":function($event){return _vm.goTo(_vm.toolsList)}}},[_c('div',[_vm._v(_vm._s(_vm.toolsList.name))]),_c('div',{staticStyle:{"color":"#999999","font-size":"14px","padding-top":"10px"}},[_vm._v(_vm._s(_vm.toolsList.intro))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }